import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import About from "../components/homi/About";
import Stats from "../components/homi/Stats";
import Features from "../components/homi/Features";
import ContactCta from "../components/homi/ContactCta";

export default function AboutPage() {
  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title="About Us" crumb="About Us" subtitle="Two decades of trusted building, renovation and repair craftsmanship." />
        <About />
        <Stats />
        <Features />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}
